var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stars-container"},_vm._l((5),function(i){return _c('img',{key:'star-' + i,staticStyle:{"width":"24px"},attrs:{"src":i <= _vm.stars ? require('../assets/icons/star.png') : require('../assets/icons/star_grey.png')},on:{"click":function($event){return _vm.setStars(i)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }